<template>
  <div>
    <v-card :outlined="outlined">
      <v-card-title class="subheading">
        {{ template.name }}
      </v-card-title>
      <v-card-subtitle v-if="template.description">
        {{ template.description }}
      </v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" lg="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon small class="mr-1"
                      >mdi-{{
                        template.category && template.category.icon
                          ? template.category.icon
                          : "shape"
                      }}</v-icon
                    >
                    {{ template.category ? template.category.title : "Keine" }}
                    <!-- <v-chip
                      v-if="template.category && template.category.type"
                      small
                      class="ml-1"
                      outlined
                    >
                      {{ getCategoryTypeLabel(template.category.type) }}
                    </v-chip> -->
                  </v-list-item-title>
                  <v-list-item-subtitle>Kategorie</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon small class="mr-1">mdi-database</v-icon>
                    {{ getContextLabel(template.placeholderContext) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>Datenkontext</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon small class="mr-1">{{
                      getDataModeIcon(template.dataMode)
                    }}</v-icon>
                    {{ getDataModeLabel(template.dataMode) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>Datenmodus</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon small class="mr-1">{{
                      getUsagePolicyIcon(template.usagePolicy)
                    }}</v-icon>
                    {{ getUsagePolicyLabel(template.usagePolicy) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Nutzungsrichtlinie
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            v-if="template.usageContexts && template.usageContexts.length > 0"
          >
            <v-card outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="mb-1">
                    <v-chip
                      v-for="ctx in template.usageContexts"
                      :key="ctx"
                      small
                      outlined
                      class="py-0 mb-0 my-1 mr-1"
                    >
                      <v-icon small left>{{ getUsageContextIcon(ctx) }}</v-icon>
                      {{ getUsageContextLabel(ctx) }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Verwendungskontext
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  PLACEHOLDER_CONTEXTS,
  USAGE_CONTEXTS,
} from "@/util/documentTemplateService.js";

export default {
  name: "document-template-detail-card",
  props: {
    template: {
      type: Object,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getCategoryTypeLabel(type) {
      const labels = {
        assignment: "Aufgabengebiet",
        unit: "Einheit",
        division: "Abteilung",
        other: "Sonstige",
      };
      return labels[type] || type;
    },
    getContextLabel(context) {
      const config = PLACEHOLDER_CONTEXTS[context];
      return config ? config.label : context;
    },
    getDataModeLabel(mode) {
      const labels = {
        single: "Einzeldatensatz",
        multi: "Mehrere Datensätze",
      };
      return labels[mode] || mode || "Einzeldatensatz";
    },
    getDataModeIcon(mode) {
      return mode === "multi" ? "mdi-file-multiple" : "mdi-file-document";
    },
    getUsagePolicyLabel(policy) {
      const labels = {
        noRestriction: "Nicht eingeschränkt",
        labelRestriction: "Eingeschränkt (Label)",
        processRestriction: "Nur in Prozessaufgaben",
        notRestricted: "Nicht eingeschränkt",
        restricted: "Eingeschränkt",
        onlyInProcessTask: "Nur in Prozessaufgaben",
      };
      return labels[policy] || policy || "Nicht eingeschränkt";
    },
    getUsagePolicyIcon(policy) {
      const icons = {
        noRestriction: "mdi-lock-open",
        labelRestriction: "mdi-shield-lock",
        processRestriction: "mdi-cog",
        notRestricted: "mdi-lock-open",
        restricted: "mdi-shield-lock",
        onlyInProcessTask: "mdi-cog",
      };
      return icons[policy] || "mdi-lock-open";
    },
    getUsageContextLabel(ctx) {
      const config = USAGE_CONTEXTS[ctx];
      return config ? config.label : ctx || "–";
    },
    getUsageContextIcon(ctx) {
      const config = USAGE_CONTEXTS[ctx];
      return config ? config.icon : "mdi-help-circle-outline";
    },
  },
};
</script>
